import { html } from 'lit';
import { LangTermsConditionsPicker } from '../../../localization/scripts/franchisee/view/terms-conditions-picker-lang.js';
import { ModalPickerDialog, ModalPickerDialogOptions } from '../../../webmodule-common/other/ui/modal-picker-base.js';
import { NullPromise } from '../../../webmodule-common/interop/types/misc.js';
import { singleSupplierId } from '../../quotes/quote-service.js';
import { TermsAndConditionsApi } from '../../api/terms-and-conditions-api.js';
import { TermsAndConditionsSummary } from '../../api/dealer-api-interface-franchisee.js';
import { TermsConditionsSummaryPickerBrowser } from './terms-conditions-list-table.js';

export interface TermsConditionsPickerOptions extends ModalPickerDialogOptions<TermsAndConditionsSummary> {
  api: TermsAndConditionsApi;
  supplierId: string | null;
}

export async function TermsConditionsPicker(api: TermsAndConditionsApi): NullPromise<TermsAndConditionsSummary> {
  return new Promise<TermsAndConditionsSummary | null>(resolve => {
    const picker = new TermsConditionsBrowserPicker({
      onSelect: (selected: TermsAndConditionsSummary | null) => {
        resolve(selected);
      },
      // eslint-disable-next-line prefer-promise-reject-errors
      onCancel: () => resolve(null),
      title: LangTermsConditionsPicker.selectTermsConditions(),
      api: api,
      supplierId: singleSupplierId()
    });
    picker.showModal().then(() => resolve(null));
  });
}

export class TermsConditionsBrowserPicker extends ModalPickerDialog<TermsAndConditionsSummary> {
  private readonly comms: TermsConditionsSummaryPickerBrowser;

  constructor(options: TermsConditionsPickerOptions) {
    super(options);

    this.comms = this.tocPickerBrowserFactory(options);
  }

  bodyTemplate() {
    return html`${this.comms}`;
  }

  footerTemplate() {
    return html`
      <webmodule-button size="small" variant="default" @click=${() => this.hideModal()}
      >${LangTermsConditionsPicker.close()}
      </webmodule-button>`;
  }

  protected tocPickerBrowserFactory(
    options: TermsConditionsPickerOptions
  ): TermsConditionsSummaryPickerBrowser {
    return new TermsConditionsSummaryPickerBrowser({
      title: () => options.title ?? '',
      onSelected: paymentProfileSummary => this.select(paymentProfileSummary),
      supplierId: options.supplierId
    });
  }
}
